import React from 'react';
import { Field } from 'redux-form';
import { renderTextField } from '../../helpers/renderFormInputs';
import ModalInformation from '../../components/modals/ModalInformation';
import { getScope } from '../../constants/modal_content/PART_1_CLINICAL_INFORMATION_SPECIMEN_RECEIPT';

export const scopeNoteJSX = () => (
  <div className="label-and-note">

    SCOPE OF REPORT
    <ModalInformation>{getScope()}</ModalInformation>
  </div>
);

export const fieldsJSX = (fields, hasWritePermission) => (
  fields.map(field => (
    <div key={field.name} className={`field-container ${field.name}`}>
      <label>{field.label}</label>
      <Field
        name={field.name}
        type={field.type}
        disabled={!hasWritePermission}
        component={renderTextField}
        className="field"
      />
    </div>
  )));